export default "__VITE_ASSET__C52LU7y4__"